import type { LocalizationResource } from "@clerk/react/types";

/**
 * Clerk calls a salon an "organization". These are the strings salon staff can meet (sign-in, the salon switcher and
 * its Manage screen); Clerk's admin-only screens (SSO, domains, billing) are unused and keep Clerk's wording.
 */
export const CLERK_LOCALIZATION: LocalizationResource = {
  organizationSwitcher: {
    notSelected: "No salon selected",
    action__openOrganizationSwitcher: "Open salon switcher",
    action__closeOrganizationSwitcher: "Close salon switcher",
  },
  organizationProfile: {
    navbar: { title: "Salon", description: "Manage your salon." },
    profilePage: {
      successMessage: "The salon has been updated.",
      dangerSection: {
        leaveOrganization: {
          title: "Leave salon",
          messageLine1: "Are you sure you want to leave this salon? You will lose access to it.",
          successMessage: "You have left the salon.",
        },
      },
    },
  },
  taskChooseOrganization: {
    chooseOrganization: {
      title: "Choose a salon",
      subtitle__createOrganizationDisabled: "Pick the salon to work in",
    },
    organizationCreationDisabled: {
      title: "You're not in a salon yet",
      subtitle: "Ask your salon's owner to invite you.",
    },
  },
  unstable__errors: {
    already_a_member_in_organization: "{{email}} is already a member of the salon.",
    organization_not_found_or_unauthorized_with_create_organization_disabled:
      "You are no longer a member of this salon. Please choose another one.",
  },
};
